import { CardContent } from '@/components/Card'
import { Button } from '@/components/Button'

export interface WaitingOnClientProgressionActionsProps {
  isOutsourcingExtension: boolean
  onReadyToFile: () => unknown
}

export function WaitingOnClientProgressionActions({
  isOutsourcingExtension,
  onReadyToFile,
}: WaitingOnClientProgressionActionsProps) {
  return (
    <CardContent>
      <Button
        label={isOutsourcingExtension ? 'Ready to Continue' : 'Ready to File'}
        variant="primary"
        size="wide-slim"
        onPress={onReadyToFile}
        testId="job-progression-set-ready-to-file-button"
      />
    </CardContent>
  )
}
